import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { t } from '../../../../../../i18n';
import { circleEmptyIcon, circleTickIcon } from '../../../../../assets';

const LessonSidebarLink = ({ to, isCurrent, isCompletedByUser, onClick, titleText, subtitleText }) => {
  return (
    <Link
      to={to}
      className={classNames(
        'courses-watch-lessons-list__lesson-item',
        isCurrent && 'courses-watch-lessons-list__lesson-item--current',
      )}
      onClick={onClick}
    >
      <div className="courses-watch-lessons-list__lesson-item-texts">
        <b className="courses-watch-lessons-list__lesson-item-texts-title">{titleText}</b>
        {subtitleText && <p className="courses-watch-lessons-list__lesson-item-texts-subtitle">{subtitleText}</p>}
      </div>
      <img
        src={isCompletedByUser ? circleTickIcon : circleEmptyIcon}
        alt={t(
          isCompletedByUser ? 'DIGITAL_COURSES.WATCH.COMPLETED_LESSON' : 'DIGITAL_COURSES.WATCH.NOT_COMPLETED_LESSON',
        )}
        title={t(
          isCompletedByUser ? 'DIGITAL_COURSES.WATCH.COMPLETED_LESSON' : 'DIGITAL_COURSES.WATCH.NOT_COMPLETED_LESSON',
        )}
      />
    </Link>
  );
};

export default LessonSidebarLink;
